import { Box } from '@material-ui/core'

interface BoxNameProps {
  selected: string
  fontSize: string
}

const BoxComponent: React.FC<BoxNameProps> = ({ selected, fontSize }) => {
  return (
    <Box
      fontWeight="500"
      fontSize={fontSize}
      style={{
        color: '#000'
      }}
    >
      {selected}
    </Box>
  )
}

export default BoxComponent
